import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=2327d959&scoped=true&"
import script from "./Email.vue?vue&type=script&lang=js&"
export * from "./Email.vue?vue&type=script&lang=js&"
import style0 from "./Email.vue?vue&type=style&index=0&id=2327d959&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327d959",
  null
  
)

export default component.exports